import type { JSX } from 'react';

import { Toggle } from '@/ui/Toggle';
import type { ToggleProps } from '@/ui/Toggle';
import { Tooltip } from '@/ui/Tooltip/Tooltip';

import type { VobListToggleCopy } from './cohorts';

interface CohortToggleProps {
  copy: VobListToggleCopy;
  checked: boolean;
  onChange: (checked: boolean) => void;
  color?: ToggleProps['color'];
  triggerClassName?: string;
}

const CohortToggle = ({
  copy,
  checked,
  onChange,
  color = 'secondary',
  triggerClassName = 'inline-flex'
}: CohortToggleProps): JSX.Element => (
  <Tooltip content={copy.description} triggerClassName={triggerClassName}>
    <Toggle size="sm" color={color} checked={checked} aria-label={copy.label} onChange={onChange}>
      {copy.label}
    </Toggle>
  </Tooltip>
);

export default CohortToggle;
